import React from 'react'

export default function OPLegendLogo() {
    return (
        <svg
            viewBox="3.83 13.16 120 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="OPLegendLogo"
        >
            <polygon
                fill="#FFF"
                strokeWidth="0px"
                points="47.7 26.47 47.16 29.09 36.98 29.09 39.76 15.2 42.99 15.2 40.73 26.47 47.7 26.47"
            />
            <polygon
                fill="#FFF"
                strokeWidth="0px"
                points="54.44 17.78 53.84 20.79 60.29 20.79 59.8 23.29 53.34 23.29 52.69 26.51 60.27 26.51 59.74 29.09 48.98 29.09 51.76 15.2 62.26 15.2 61.72 17.78 54.44 17.78"
            />
            <path
                fill="#FFF"
                strokeWidth="0px"
                d="M73.13,21.93h2.94l-1.15,5.71c-.7.54-1.52.96-2.44,1.25-.92.29-1.88.44-2.88.44-1.4,0-2.62-.25-3.65-.76-1.02-.51-1.82-1.22-2.39-2.12-.55-.91-.83-1.96-.83-3.16s.21-2.27.62-3.29c.42-1.02,1.02-1.9,1.78-2.64.77-.75,1.69-1.34,2.76-1.77,1.07-.42,2.26-.63,3.57-.63s2.47.21,3.44.63c.98.41,1.77,1.01,2.36,1.79l-2.3,1.87c-.46-.56-.99-.96-1.59-1.2-.58-.23-1.26-.35-2.04-.35-.82,0-1.57.14-2.23.41-.65.27-1.2.65-1.66,1.14-.47.48-.82,1.06-1.08,1.72-.25.65-.37,1.36-.37,2.13,0,.7.15,1.31.45,1.84.31.52.76.92,1.35,1.21.61.29,1.35.44,2.23.44.66,0,1.29-.11,1.9-.34.13-.05.26-.1.39-.16l.82-4.16Z"
            />
            <polygon
                fill="#FFF"
                strokeWidth="0px"
                points="83.07 17.78 82.47 20.79 88.92 20.79 88.43 23.29 81.97 23.29 81.32 26.51 88.9 26.51 88.37 29.09 77.61 29.09 80.39 15.2 90.89 15.2 90.35 17.78 83.07 17.78"
            />
            <polygon
                fill="#FFF"
                strokeWidth="0px"
                points="106.45 15.2 103.67 29.09 101.03 29.09 95.85 20.4 94.1 29.09 90.92 29.09 93.7 15.2 96.36 15.2 101.54 23.92 103.27 15.2 106.45 15.2"
            />
            <path
                fill="#FFF"
                strokeWidth="0px"
                d="M121.58,17.92c-.54-.88-1.33-1.55-2.36-2.01-1.02-.48-2.24-.71-3.67-.71h-5.82l-2.77,13.89h6.78c1.29,0,2.46-.19,3.52-.58,1.06-.38,1.97-.92,2.74-1.62.76-.72,1.35-1.57,1.76-2.56.43-1,.64-2.11.64-3.34s-.27-2.21-.82-3.07ZM118.51,23.87c-.41.79-1.01,1.42-1.81,1.89-.78.46-1.73.69-2.86.69h-3.13l1.72-8.61h2.76c.88,0,1.6.14,2.19.41.59.27,1.03.65,1.33,1.15.29.49.43,1.08.43,1.77,0,1.01-.21,1.91-.63,2.7Z"
            />
            <g>
                <path
                    fill="#e37717"
                    fillRule="evenodd"
                    strokeWidth="0px"
                    d="M9.46,13.16c-1.03,0-1.93.7-2.18,1.71l-3.38,13.45c-.36,1.43.72,2.81,2.19,2.81h22.41c1.03,0,1.93-.71,2.19-1.71l4.08-16.26H9.46ZM28.57,28.89s-.04.06-.07.06H6.09s-.03,0-.04,0c0,0-.01-.01-.02-.02-.01-.01-.02-.03-.02-.03v-.04l3.38-13.45s.04-.06.07-.06h22.51l-3.4,13.55Z"
                />
                <path
                    fill="#e37717"
                    fillRule="evenodd"
                    strokeWidth="0px"
                    d="M12.33,17.72c-.5,0-.93.35-1.06.84l-1.65,6.67c-.18.71.35,1.39,1.06,1.39h5.37c.5,0,.93-.35,1.06-.84l1.45-5.84h7.37l-.43,1.81c-.06.24-.28.42-.53.42h-3.98c-.6,0-1.12.43-1.26,1.03l-.82,3.42h2.24l.54-2.23h4.55c.5,0,.93-.35,1.05-.84l1.46-5.83H12.33ZM15.37,23.97c-.06.25-.28.42-.53.42h-2.15c-.35,0-.61-.34-.53-.69l.83-3.34c.06-.24.28-.42.53-.42h2.85l-1,4.03Z"
                />
            </g>
        </svg>
    )
}
